export const theme = {
  colors: {
    orange: '#fd8360',
    orangeDark: '#e86b46',
    orangeLight: '#fff0eb',
    blue: '#0066ff',
    black: '#1a1a1a',
    dark: '#333',
    mid: '#666',
    border: '#e0e0e0',
    bgLight: '#f5f5f5',
    white: '#ffffff',
  },
  fonts: {
    display: "'Syne', sans-serif",
    body: "'DM Sans', sans-serif",
  },
};
